import { useState, useEffect } from "react";
import { personalInfo } from "../data/index";

const phrases = [
  "Software Engineer.",
  "React Specialist.",
  "Problem Solver.",
  "The Engineer You Need.",
];

export default function Hero() {
  const [displayText, setDisplayText] = useState("");

  useEffect(() => {
    let current = "";
    let charIndex = 0;
    let phraseIndex = 0;
    let deleting = false;
    let timeout;

    function type() {
      const phrase = phrases[phraseIndex];

      if (!deleting) {
        current = phrase.slice(0, charIndex + 1);
        charIndex++;
        if (charIndex === phrase.length) {
          deleting = true;
          timeout = setTimeout(type, 1800);
          return;
        }
      } else {
        current = phrase.slice(0, charIndex - 1);
        charIndex--;
        if (charIndex === 0) {
          deleting = false;
          phraseIndex = (phraseIndex + 1) % phrases.length;
        }
      }

      setDisplayText(current);
      timeout = setTimeout(type, deleting ? 60 : 100);
    }

    timeout = setTimeout(type, 500);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <section
      id="hero"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0 24px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "20%",
          right: "10%",
          width: "400px",
          height: "400px",
          background:
            "radial-gradient(circle,rgba(34, 211, 238),0.06) 0%, transparent 70%)",
          borderRadius: "50%",
          pointerEvents: "none",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "20%",
          left: "5%",
          width: "300px",
          height: "300px",
          background:
            "radial-gradient(circle,rgba(34, 211, 238),0.04) 0%, transparent 70%)",
          borderRadius: "50%",
          pointerEvents: "none",
        }}
      />

      <div
        style={{
          maxWidth: "900px",
          width: "100%",
          animation: "fadeInUp 0.8s ease forwards",
        }}
      >
        <p
          style={{
            color: "#22d3ee",
            fontSize: "1rem",
            fontWeight: 600,
            letterSpacing: "3px",
            textTransform: "uppercase",
            marginBottom: "20px",
          }}
        >
          👋 Hello, I am
        </p>

        <h1
          style={{
            fontSize: "clamp(3rem, 8vw, 6rem)",
            fontWeight: 900,
            color: "#f5f5f5",
            lineHeight: 1.05,
            marginBottom: "16px",
            letterSpacing: "-2px",
          }}
        >
          {personalInfo.name.split(" ")[0]}{" "}
          <span style={{ color: "#22d3ee" }}>
            {personalInfo.name.split(" ").slice(1).join(" ")}
          </span>
        </h1>

        <div
          style={{
            fontSize: "clamp(1.4rem, 3vw, 2rem)",
            fontWeight: 700,
            color: "#a0a0a0",
            marginBottom: "28px",
            height: "48px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <span style={{ color: "#f5f5f5" }}>{displayText}</span>
          <span
            style={{
              display: "inline-block",
              width: "3px",
              height: "2rem",
              background: "#22d3ee",
              animation: "blink 1s infinite",
              borderRadius: "2px",
            }}
          />
        </div>

        <p
          style={{
            fontSize: "1.1rem",
            color: "#a0a0a0",
            maxWidth: "600px",
            lineHeight: 1.8,
            marginBottom: "48px",
          }}
        >
          {personalInfo.about}
        </p>

        <div
          style={{
            display: "flex",
            gap: "16px",
            flexWrap: "wrap",
          }}
        >
          <a
            href="#projects"
            style={{
              background: "#22d3ee",
              color: "#1a1a1a",
              padding: "16px 32px",
              borderRadius: "12px",
              fontSize: "1rem",
              fontWeight: 700,
              textDecoration: "none",
              transition: "all 0.3s ease",
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-3px)";
              e.currentTarget.style.boxShadow =
                "0 0 30pxrgba(34, 211, 238),0.4)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            View My Work →
          </a>

          <a
            href="#contact"
            style={{
              background: "transparent",
              color: "#22d3ee",
              padding: "16px 32px",
              borderRadius: "12px",
              fontSize: "1rem",
              fontWeight: 700,
              textDecoration: "none",
              border: "1.5px solid #22d3ee",
              transition: "all 0.3s ease",
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-3px)";
              e.currentTarget.style.background = "rgba(57,255,20,0.1)";
              e.currentTarget.style.boxShadow =
                "0 0 20pxrgba(34, 211, 238),0.2)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.background = "transparent";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            Let's Talk
          </a>
        </div>

        <div
          style={{
            display: "flex",
            gap: "24px",
            marginTop: "60px",
          }}
        >
          {[
            { number: "7+", label: "Years Experience" },
            { number: "45%", label: "Revenue Increase" },
            { number: "90%", label: "Issue Resolution" },
          ].map((stat) => (
            <div key={stat.label}>
              <p
                style={{
                  fontSize: "2rem",
                  fontWeight: 900,
                  color: "#22d3ee",
                  lineHeight: 1,
                  marginBottom: "4px",
                }}
              >
                {stat.number}
              </p>
              <p
                style={{
                  fontSize: "0.8rem",
                  color: "#666",
                  fontWeight: 500,
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                }}
              >
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
